export enum TimeTrackingMode {
    COMPACT = "COMPACT",
    INDIVIDUAL = "INDIVIDUAL",
}

export enum ReceiptSettingsType {
    BILL = "BILL",
    DELIVERY_NOTE = "DELIVERY_NOTE",
    OFFER = "OFFER",
    CREDIT_NOTE = "CREDIT_NOTE",
}

export enum ReceiptContactType {
    FIXED = "FIXED",
    CREATOR = "CREATOR",
}
export type FixedReceiptContact = {
    type: ReceiptContactType.FIXED;
    contactPerson: string;
    contactPhone: string;
};
type CreatorReceiptContact = {
    type: ReceiptContactType.CREATOR;
};

export abstract class ReceiptSettings {
    public intro: string;
    public outro: string;
    public contact: FixedReceiptContact | CreatorReceiptContact;
    public prefix: string;
    public nextReceiptNumber: number;
    public showReceiptFooter: boolean;
    public showLogoHeader: boolean;
    public showAddressHeader: boolean;
    public freePositionsText: string;
    public salutation: boolean;
    public abstract type: ReceiptSettingsType;

    protected constructor(initialValues?: Partial<ReceiptSettings>) {
        this.intro = initialValues?.intro ?? "";
        this.outro = initialValues?.outro ?? "";
        this.prefix = initialValues?.prefix ?? "BE-";
        this.nextReceiptNumber = initialValues?.nextReceiptNumber ?? 1;
        this.showReceiptFooter = initialValues?.showReceiptFooter ?? true;
        this.showLogoHeader = initialValues?.showLogoHeader ?? true;
        this.contact = initialValues?.contact ?? {
            type: ReceiptContactType.FIXED,
            contactPerson: "",
            contactPhone: "",
        };
        this.showAddressHeader = initialValues?.showAddressHeader ?? true;
        this.freePositionsText = initialValues?.freePositionsText ?? "Freie Positionen";
        this.salutation = initialValues?.salutation ?? false;
    }
}

export const CONTACT_VARIANT_TYPE_SELECT_DATA = [
    { label: "Fester Name", value: ReceiptContactType.FIXED },
    { label: "Beleg-Ersteller", value: ReceiptContactType.CREATOR },
];
